// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextArea_textArea__u0Mw_","textAreaDark":"TextArea_textAreaDark__JShP_","hiddenTextAreaLabel":"TextArea_hiddenTextAreaLabel__QW9kM","error":"TextArea_error__cegsk"};